import React from 'react';
import { FaVideo, FaCogs, FaCameraRetro } from 'react-icons/fa';
import './AboutUsDetails.css';

const AboutUsDetails = () => {
  const sections = [
    {
      id: 1,
      icon: <FaVideo />,
      title: 'We Are the Best at What We Do',
      description:
        'We are a passionate film production house in Jaipur offering full-service video production, gear rental, and travel coordination. We bring your creative vision to life from concept to completion.',
    },
    {
      id: 2,
      icon: <FaCogs />,
      title: 'What We Do',
      description:
        "Dreamscape Studios is a top video production company offering flexible production support. From casting to on-set services, we assist photographers, agencies, and video production firms with local expertise and talent.",
    },
    {
      id: 3,
      icon: <FaCameraRetro />,
      title: 'Our Work',
      description:
        'We are a video production company specializing in product, fashion, and lifestyle photography, along with Television Commercials and Digital Films. Our videography production is known for striking visuals, top gear, and expert crews. We’ve worked with Tata Harrier, Air India, and global productions like Amazing Race.',
    },
  ];

  return (
    <section className="about-us-details-section">
      <div className="about-us-container">
        <h2 className="about-us-section-title">About Dreamscape Studios</h2>
        <div className="about-us-sections">
          {sections.map((section) => (
            <div className="about-us-section-item" key={section.id}>
              <div className="about-us-icon">{section.icon}</div>
              <div className="about-us-text-content">
                <h3 className="about-us-section-title">{section.title}</h3>
                <p className="about-us-section-description">{section.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutUsDetails;
